import { Shield, Wind, Sun, Mic, Music, Phone, X, Award, Check } from 'lucide-react';

export interface StoreLink {
  name: string;
  url: string;
}

export type CertificationType = 'ECE' | 'DOT' | 'ECE_DOT';

export interface Product {
  id: string;
  name: string;
  type: 'Jet' | 'Integral' | 'Modular' | 'Cross';
  price: number;
  category: ('Ciudad' | 'Trabajo' | 'Carretera' | 'Trayectos Cortos' | 'Viajes Largos' | 'Off-Road')[];
  image: string;
  images: string[];
  hoverImage?: string;
  description: string;
  recommendedUses?: string[];
  keywords?: string[];
  storeLinks?: StoreLink[];
  certificateUrl?: string;
  certificationType?: CertificationType;
  features: {
    abs: boolean;
    ventilation: boolean;
    quickRelease: boolean;
    uvProtection: boolean;
    removableInterior: boolean;
    safetyStrap: boolean;
    bluetooth?: boolean;
  };
}

export const PRODUCTS: Product[] = [
  {
    id: '1',
    name: 'BOLT',
    type: 'Jet',
    price: 0,
    category: ['Ciudad', 'Trayectos Cortos', 'Trabajo'],
    image: '/product_images/bolt/7502290554506_02.jpg',
    images: [
      '/product_images/bolt/7502290554506_02.jpg',
      '/product_images/bolt/7502290554506_01.jpg',
      '/product_images/bolt/7502290554506_03.jpg',
      '/product_images/bolt/7502290554506_04.jpg'
    ],
    description: 'Los cascos JET para motocicleta son ideales para quienes buscan comodidad, ligereza y ventilación en la ciudad. Su diseño abierto proporciona un amplio campo de visión y una experiencia de manejo más fresca, perfecta para trayectos urbanos y climas cálidos. Son una excelente opción para scooters y motos urbanas, combinando estilo y practicidad para el uso diario.',
    recommendedUses: [
      'Ciudad y trayectos cortos',
      'Motocicletas urbanas y scooters',
      'Climas cálidos'
    ],
    keywords: ['casco jet', 'casco abierto para moto', 'casco urbano', 'casco para scooter'],
    storeLinks: [],
    certificateUrl: 'https://qrco.de/bgROEz',
    certificationType: 'DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '2',
    name: 'DRAGON',
    type: 'Integral',
    price: 0,
    category: ['Carretera', 'Ciudad', 'Viajes Largos'],
    image: '/product_images/dragon/Dragon02.jpg',
    images: [
      '/product_images/dragon/Dragon02.jpg',
      '/product_images/dragon/Dragon01.jpg',
      '/product_images/dragon/Dragon03.jpg',
      '/product_images/dragon/Dragon04.jpg',
      '/product_images/dragon/Dragon05.jpg'
    ],
    description: 'Los cascos integrales ofrecen el máximo nivel de protección para motociclistas, cubriendo completamente la cabeza y el mentón. Su diseño aerodinámico reduce el ruido y mejora la estabilidad a altas velocidades, convirtiéndolos en la opción preferida para carretera y uso diario. Seguridad, confort y rendimiento en un solo casco.',
    recommendedUses: [
      'Ciudad y carretera',
      'Viajes largos',
      'Conducción a velocidades medias y altas'
    ],
    keywords: ['casco integral', 'casco de moto seguro', 'casco para carretera', 'casco deportivo'],
    storeLinks: [
      { name: 'Elektra', url: 'https://www.elektra.mx/casco-integral-dragon-morado-grande-34006615/p' }
    ],
    certificateUrl: 'https://qrco.de/bfmNq8',
    certificationType: 'ECE_DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '3', //Jet
    name: 'MRC-06',
    type: 'Jet',
    price: 0,
    category: ['Ciudad', 'Trayectos Cortos'],
    image: '/product_images/mrc-06/MRC-06N_02.jpg',
    images: [
      '/product_images/mrc-06/MRC-06N_02.jpg',
      '/product_images/mrc-06/MRC-06N_01.jpg',
      '/product_images/mrc-06/MRC-06N_03.jpg',
      '/product_images/mrc-06/MRC-06N_04.jpg'
    ],
    description: 'Los cascos JET para motocicleta son ideales para quienes buscan comodidad, ligereza y ventilación en la ciudad. Su diseño abierto proporciona un amplio campo de visión y una experiencia de manejo más fresca, perfecta para trayectos urbanos y climas cálidos. Son una excelente opción para scooters y motos urbanas, combinando estilo y practicidad para el uso diario.',
    recommendedUses: [
      'Ciudad y trayectos cortos',
      'Motocicletas urbanas y scooters',
      'Climas cálidos'
    ],
    keywords: ['casco jet', 'casco abierto para moto', 'casco urbano', 'casco para scooter'],
    storeLinks: [],
    certificateUrl: 'https://qrco.de/bfmNrD',
    certificationType: 'DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '4',
    name: 'GRID',
    type: 'Jet',
    price: 0,
    category: ['Ciudad', 'Trayectos Cortos'],
    image: '/product_images/grid/Grid03.jpg',
    images: [
      '/product_images/grid/Grid03.jpg',
      '/product_images/grid/Grid01.jpg',
      '/product_images/grid/Grid02.jpg',
      '/product_images/grid/Grid04.jpg'
    ],
    description: 'Los cascos JET para motocicleta son ideales para quienes buscan comodidad, ligereza y ventilación en la ciudad. Su diseño abierto proporciona un amplio campo de visión y una experiencia de manejo más fresca, perfecta para trayectos urbanos y climas cálidos. Son una excelente opción para scooters y motos urbanas, combinando estilo y practicidad para el uso diario.',
    recommendedUses: [
      'Ciudad y trayectos cortos',
      'Motocicletas urbanas y scooters',
      'Climas cálidos'
    ],
    keywords: ['casco jet', 'casco abierto para moto', 'casco urbano', 'casco para scooter'],
    storeLinks: [],
    certificateUrl: 'https://qrco.de/bgROII',
    certificationType: 'ECE_DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '5',
    name: 'SAMURAI',
    type: 'Integral',
    price: 0,
    category: ['Carretera', 'Ciudad', 'Viajes Largos'],
    image: '/product_images/samurai/Samurai03.jpg',
    images: [
      '/product_images/samurai/Samurai01.jpg',
      '/product_images/samurai/Samurai02.jpg',
      '/product_images/samurai/Samurai04.jpg'
    ],
    description: 'Los cascos integrales ofrecen el máximo nivel de protección para motociclistas, cubriendo completamente la cabeza y el mentón. Su diseño aerodinámico reduce el ruido y mejora la estabilidad a altas velocidades, convirtiéndolos en la opción preferida para carretera y uso diario. Seguridad, confort y rendimiento en un solo casco.',
    recommendedUses: [
      'Ciudad y carretera',
      'Viajes largos',
      'Conducción a velocidades medias y altas'
    ],
    keywords: ['casco integral', 'casco de moto seguro', 'casco para carretera', 'casco deportivo'],
    storeLinks: [],
    certificateUrl: 'https://qrco.de/bgROFl',
    certificationType: 'ECE_DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '6',
    name: 'XTREAM',
    type: 'Cross',
    price: 0,
    category: ['Carretera', 'Off-Road'],
    image: '/product_images/xtream/7502290554629_03.jpg',
    images: [
      '/product_images/xtream/7502290554629_03.jpg',
      '/product_images/xtream/7502290554629_01.jpg',
      '/product_images/xtream/7502290554629_02.jpg',
      '/product_images/xtream/7502290554629_04.jpg'
    ],
    description: 'Los cascos cross para motocross y enduro están diseñados para ofrecer máxima ventilación, ligereza y resistencia en terrenos extremos. Su estructura reforzada y compatibilidad con goggles los hacen ideales para uso off-road, brindando protección confiable en condiciones exigentes.',
    recommendedUses: [
      'Motocross',
      'Enduro',
      'Uso off-road'
    ],
    keywords: ['casco cross', 'casco motocross', 'casco off-road', 'casco enduro'],
    storeLinks: [],
    certificateUrl: 'https://qrco.de/bgROIf',
    certificationType: 'ECE_DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '7',
    name: 'RACE',
    type: 'Modular',
    price: 0,
    category: ['Carretera', 'Ciudad'],
    image: '/product_images/race/Race02.jpg',
    images: [
      '/product_images/race/Race02.jpg',
      '/product_images/race/Race01.jpg',
      '/product_images/race/Race03.jpg',
      '/product_images/race/Race04.jpg',
      '/product_images/race/Race05.jpg'
    ],
    description: 'Los cascos modulares combinan la protección de un casco integral con la versatilidad de un casco abierto. Gracias a su mentonera abatible, ofrecen mayor comodidad durante viajes largos y paradas frecuentes. Son ideales para motociclistas touring o delivery que buscan practicidad sin comprometer la seguridad.',
    recommendedUses: [
      'Treyectos con paradas frecuentes',
      'Viajes largos',
      'Ciudad y carretera'
    ],
    keywords: ['casco modular', 'casco abatible', 'casco touring', 'casco para viajes largos'],
    storeLinks: [
      { name: 'Elektra', url: 'https://www.elektra.mx/casco-abatible-mrc-race-azul-extra-grande-34006606/p' }
    ],
    certificateUrl: 'https://qrco.de/bfmRBz',
    certificationType: 'ECE_DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '8',
    name: 'TED',
    type: 'Modular',
    price: 0,
    category: ['Carretera', 'Ciudad'],
    image: '/product_images/ted/7502290554476_03.jpg',
    images: [
      '/product_images/ted/7502290554476_03.jpg',
      '/product_images/ted/7502290554476_01.jpg',
      '/product_images/ted/7502290554476_02.jpg',
      '/product_images/ted/7502290554476_04.jpg'
    ],
    description: 'Los cascos modulares combinan la protección de un casco integral con la versatilidad de un casco abierto. Gracias a su mentonera abatible, ofrecen mayor comodidad durante viajes largos y paradas frecuentes. Son ideales para motociclistas touring o delivery que buscan practicidad sin comprometer la seguridad.',
    recommendedUses: [
      'Treyectos con paradas frecuentes',
      'Viajes largos',
      'Ciudad y carretera'
    ],
    keywords: ['casco modular', 'casco abatible', 'casco touring', 'casco para viajes largos'],
    storeLinks: [],
    certificateUrl: 'https://qrco.de/bgRODP',
    certificationType: 'DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '9', //Cross
    name: 'CHERNOBYL',
    type: 'Cross',
    price: 0,
    category: ['Carretera', 'Off-Road'],
    image: '/product_images/chernobyl/Chernobyl02.jpg',
    images: [
      '/product_images/chernobyl/Chernobyl02.jpg',
      '/product_images/chernobyl/Chernobyl01.jpg',
      '/product_images/chernobyl/Chernobyl03.jpg',
      '/product_images/chernobyl/Chernobyl04.jpg',
      '/product_images/chernobyl/Chernobyl05.jpg'
    ],
    description: 'Los cascos cross para motocross y enduro están diseñados para ofrecer máxima ventilación, ligereza y resistencia en terrenos extremos. Su estructura reforzada y compatibilidad con goggles los hacen ideales para uso off-road, brindando protección confiable en condiciones exigentes.',
    recommendedUses: [
      'Motocross',
      'Enduro',
      'Uso off-road'
    ],
    keywords: ['casco cross', 'casco motocross', 'casco off-road', 'casco enduro'],
    storeLinks: [
      { name: 'Elektra', url: 'https://www.elektra.mx/casco-modular-mrc-chernobyl-morado-grande-34006609/p' },
      { name: 'ITALIKA', url: 'https://www.italika.mx/casco-modular-mrc-chernobyl-morado-extra-grande-34006644/p' }
    ],
    certificateUrl: 'https://qrco.de/bfmRAp',
    certificationType: 'DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '10',
    name: 'SCRATCH II',
    type: 'Modular',
    price: 0,
    category: ['Carretera', 'Ciudad'],
    image: '/product_images/scratch-ii/ScratchII_03.jpg',
    images: [
      '/product_images/scratch-ii/ScratchII_01.jpg',
      '/product_images/scratch-ii/ScratchII_02.jpg',
      '/product_images/scratch-ii/ScratchII_03.jpg',
      '/product_images/scratch-ii/ScratchII_04.jpg'
    ],
    description: 'Los cascos modulares combinan la protección de un casco integral con la versatilidad de un casco abierto. Gracias a su mentonera abatible, ofrecen mayor comodidad durante viajes largos y paradas frecuentes. Son ideales para motociclistas touring o delivery que buscan practicidad sin comprometer la seguridad.',
    recommendedUses: [
      'Treyectos con paradas frecuentes',
      'Viajes largos',
      'Ciudad y carretera'
    ],
    keywords: ['casco modular', 'casco abatible', 'casco touring', 'casco para viajes largos'],
    storeLinks: [],
    certificateUrl: 'https://qrco.de/bgROBm',
    certificationType: 'ECE_DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '11',
    name: 'NARDO',
    type: 'Modular',
    price: 0,
    category: ['Carretera', 'Ciudad'],
    image: '/product_images/nardo/Sky02.jpg',
    images: [
      '/product_images/nardo/Sky02.jpg',
      '/product_images/nardo/Sky01.jpg',
      '/product_images/nardo/Sky03.jpg',
      '/product_images/nardo/Sky04.jpg',
      '/product_images/nardo/Sky05.jpg'
    ],
    description: 'Los cascos modulares combinan la protección de un casco integral con la versatilidad de un casco abierto. Gracias a su mentonera abatible, ofrecen mayor comodidad durante viajes largos y paradas frecuentes. Son ideales para motociclistas touring o delivery que buscan practicidad sin comprometer la seguridad.',
    recommendedUses: [
      'Treyectos con paradas frecuentes',
      'Viajes largos',
      'Ciudad y carretera'
    ],
    keywords: ['casco modular', 'casco abatible', 'casco touring', 'casco para viajes largos'],
    storeLinks: [
      { name: 'Elektra', url: 'https://www.elektra.mx/casco-abatible-nardo-gris-grande-34006596/p' }
    ],
    certificateUrl: 'https://qrco.de/bfmRBz',
    certificationType: 'ECE_DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '12',
    name: 'SCRATCH',
    type: 'Modular',
    price: 0,
    category: ['Carretera', 'Ciudad'],
    image: '/product_images/scratch/Scratch02.jpg',
    images: [
      '/product_images/scratch/Scratch02.jpg',
      '/product_images/scratch/Scratch01.jpg',
      '/product_images/scratch/Scratch03.jpg',
      '/product_images/scratch/Scratch04.jpg',
      '/product_images/scratch/Scratch05.jpg'
    ],
    description: 'Los cascos modulares combinan la protección de un casco integral con la versatilidad de un casco abierto. Gracias a su mentonera abatible, ofrecen mayor comodidad durante viajes largos y paradas frecuentes. Son ideales para motociclistas touring o delivery que buscan practicidad sin comprometer la seguridad.',
    recommendedUses: [
      'Treyectos con paradas frecuentes',
      'Viajes largos',
      'Ciudad y carretera'
    ],
    keywords: ['casco modular', 'casco abatible', 'casco touring', 'casco para viajes largos'],
    storeLinks: [
      { name: 'Elektra', url: 'https://www.elektra.mx/casco-abatible-scratch-azul-extra-grande-34006618/p' }
    ],
    certificateUrl: 'https://qrco.de/bfmNWA',
    certificationType: 'ECE_DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '13',
    name: 'WILD',
    type: 'Modular',
    price: 0,
    category: ['Carretera', 'Ciudad'],
    image: '/product_images/wild/Wild03.jpg',
    images: [
      '/product_images/wild/Wild03.jpg',
      '/product_images/wild/Wild01.jpg',
      '/product_images/wild/Wild02.jpg',
      '/product_images/wild/Wild04.jpg'
    ],
    description: 'Los cascos modulares combinan la protección de un casco integral con la versatilidad de un casco abierto. Gracias a su mentonera abatible, ofrecen mayor comodidad durante viajes largos y paradas frecuentes. Son ideales para motociclistas touring o delivery que buscan practicidad sin comprometer la seguridad.',
    recommendedUses: [
      'Treyectos con paradas frecuentes',
      'Viajes largos',
      'Ciudad y carretera'
    ],
    keywords: ['casco modular', 'casco abatible', 'casco touring', 'casco para viajes largos'],
    storeLinks: [],
    certificateUrl: 'https://qrco.de/bgROCU',
    certificationType: 'DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '14',
    name: 'POTION',
    type: 'Integral',
    price: 0,
    category: ['Carretera', 'Ciudad', 'Viajes Largos'],
    image: '/product_images/potion/Potion02.jpg',
    images: [
      '/product_images/potion/Potion02.jpg',
      '/product_images/potion/Potion01.jpg',
      '/product_images/potion/Potion03.jpg',
      '/product_images/potion/Potion04.jpg',
      '/product_images/potion/Potion05.jpg'
    ],
    description: 'Los cascos integrales ofrecen el máximo nivel de protección para motociclistas, cubriendo completamente la cabeza y el mentón. Su diseño aerodinámico reduce el ruido y mejora la estabilidad a altas velocidades, convirtiéndolos en la opción preferida para carretera y uso diario. Seguridad, confort y rendimiento en un solo casco.',
    recommendedUses: [
      'Ciudad y carretera',
      'Viajes largos',
      'Conducción a velocidades medias y altas'
    ],
    keywords: ['casco integral', 'casco de moto seguro', 'casco para carretera', 'casco deportivo'],
    storeLinks: [
      { name: 'Elektra', url: 'https://www.elektra.mx/casco-integral-mrc-potion-multicolor-grande-34006635/p' },
      { name: 'ITALIKA', url: 'https://www.italika.mx/casco-integral-mrc-potion-multicolor-extra-grande-34006642/p' }
    ],
    certificateUrl: 'https://qrco.de/bfmNq8',
    certificationType: 'ECE_DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '15', //Modular
    name: 'MRC-207',
    type: 'Modular',
    price: 0,
    category: ['Carretera', 'Ciudad'],
    image: '/product_images/mrc-207/casco3b.jpg',
    images: [
      '/product_images/mrc-207/casco3b.jpg',
      '/product_images/mrc-207/casco3d.jpg',
      '/product_images/mrc-207/casco3a.jpg',
      '/product_images/mrc-207/casco3c.jpg',
    ],
    description: 'Los cascos modulares combinan la protección de un casco integral con la versatilidad de un casco abierto. Gracias a su mentonera abatible, ofrecen mayor comodidad durante viajes largos y paradas frecuentes. Son ideales para motociclistas touring o delivery que buscan practicidad sin comprometer la seguridad.',
    recommendedUses: [
      'Treyectos con paradas frecuentes',
      'Viajes largos',
      'Ciudad y carretera'
    ],
    keywords: ['casco modular', 'casco abatible', 'casco touring', 'casco para viajes largos'],
    storeLinks: [
      { name: 'Elektra', url: 'https://www.elektra.mx/casco-abatible-mrc-207fc-negro-grande-34006327/p' }
    ],
    certificateUrl: 'https://qrco.de/bfmNWA',
    certificationType: 'DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '16',
    name: 'SHOUT',
    type: 'Integral',
    price: 0,
    category: ['Carretera', 'Ciudad', 'Viajes Largos'],
    image: '/product_images/shout/Shout02.jpg',
    images: [
      '/product_images/shout/Shout02.jpg',
      '/product_images/shout/Shout01.jpg',
      '/product_images/shout/Shout03.jpg',
      '/product_images/shout/Shout04.jpg',
      '/product_images/shout/Shout05.jpg'
    ],
    description: 'Los cascos integrales ofrecen el máximo nivel de protección para motociclistas, cubriendo completamente la cabeza y el mentón. Su diseño aerodinámico reduce el ruido y mejora la estabilidad a altas velocidades, convirtiéndolos en la opción preferida para carretera y uso diario. Seguridad, confort y rendimiento en un solo casco.',
    recommendedUses: [
      'Ciudad y carretera',
      'Viajes largos',
      'Conducción a velocidades medias y altas'
    ],
    keywords: ['casco integral', 'casco de moto seguro', 'casco para carretera', 'casco deportivo'],
    storeLinks: [
      { name: 'Elektra', url: 'https://www.elektra.mx/casco-integral-shout-negro-con-rosa-mediano-34006607/p' }
    ],
    certificateUrl: 'https://qrco.de/bfmNq8',
    certificationType: 'ECE_DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '17',
    name: 'MRC-18',
    type: 'Integral',
    price: 0,
    category: ['Carretera', 'Ciudad', 'Viajes Largos'],
    image: '/product_images/mrc-18/casco 7b.jpg',
    images: [
      '/product_images/mrc-18/casco 7b.jpg',
      '/product_images/mrc-18/casco 7a.jpg',
      '/product_images/mrc-18/casco 7c.jpg',
      '/product_images/mrc-18/casco 7d.jpg'
    ],
    description: 'Los cascos integrales ofrecen el máximo nivel de protección para motociclistas, cubriendo completamente la cabeza y el mentón. Su diseño aerodinámico reduce el ruido y mejora la estabilidad a altas velocidades, convirtiéndolos en la opción preferida para carretera y uso diario. Seguridad, confort y rendimiento en un solo casco.',
    recommendedUses: [
      'Ciudad y carretera',
      'Viajes largos',
      'Conducción a velocidades medias y altas'
    ],
    keywords: ['casco integral', 'casco de moto seguro', 'casco para carretera', 'casco deportivo'],
    storeLinks: [
      { name: 'Elektra', url: 'https://www.elektra.mx/casco-integral-mrc-18n-negro-mediana-34006329/p' }
    ],
    certificateUrl: 'https://qrco.de/bfc19l',
    certificationType: 'DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '18',
    name: 'STORY',
    type: 'Integral',
    price: 0,
    category: ['Carretera', 'Ciudad', 'Viajes Largos'],
    image: '/product_images/story/Story02.jpg',
    images: [
      '/product_images/story/Story02.jpg',
      '/product_images/story/Story01.jpg',
      '/product_images/story/Story03.jpg',
      '/product_images/story/Story04.jpg',
      '/product_images/story/Story05.jpg'
    ],
    description: 'Los cascos integrales ofrecen el máximo nivel de protección para motociclistas, cubriendo completamente la cabeza y el mentón. Su diseño aerodinámico reduce el ruido y mejora la estabilidad a altas velocidades, convirtiéndolos en la opción preferida para carretera y uso diario. Seguridad, confort y rendimiento en un solo casco.',
    recommendedUses: [
      'Ciudad y carretera',
      'Viajes largos',
      'Conducción a velocidades medias y altas'
    ],
    keywords: ['casco integral', 'casco de moto seguro', 'casco para carretera', 'casco deportivo'],
    storeLinks: [
      { name: 'Elektra', url: 'https://www.elektra.mx/casco-integral-mrc-story-multicolor-grande-34006636/p' },
      { name: 'ITALIKA', url: 'https://www.italika.mx/casco-integral-mrc-story-multicolor-extra-grande-34006643/p' }
    ],
    certificateUrl: 'https://qrco.de/bfmNpN',
    certificationType: 'DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '19',
    name: 'THUNDER',
    type: 'Modular',
    price: 0,
    category: ['Carretera', 'Ciudad'],
    image: '/product_images/thunder/Thunder_03.jpg',
    images: [
      '/product_images/thunder/Thunder_03.jpg',
      '/product_images/thunder/Thunder_02.jpg',
      '/product_images/thunder/Thunder_01.jpg',
      '/product_images/thunder/Thunder_04.jpg'
    ],
    description: 'Los cascos modulares combinan la protección de un casco integral con la versatilidad de un casco abierto. Gracias a su mentonera abatible, ofrecen mayor comodidad durante viajes largos y paradas frecuentes. Son ideales para motociclistas touring o delivery que buscan practicidad sin comprometer la seguridad.',
    recommendedUses: [
      'Treyectos con paradas frecuentes',
      'Viajes largos',
      'Ciudad y carretera'
    ],
    keywords: ['casco modular', 'casco abatible', 'casco touring', 'casco para viajes largos'],
    storeLinks: [],
    certificateUrl: 'https://qrco.de/bg0rex',
    certificationType: 'DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '20',
    name: 'PANTHER',
    type: 'Integral',
    price: 0,
    category: ['Carretera', 'Ciudad', 'Viajes Largos'],
    image: '/product_images/panther/7502290554520_03.jpg',
    images: [
      '/product_images/panther/7502290554520_03.jpg',
      '/product_images/panther/7502290554520_02.jpg',
      '/product_images/panther/7502290554520_01.jpg',
      '/product_images/panther/7502290554520_04.jpg'
    ],
    description: 'Los cascos integrales ofrecen el máximo nivel de protección para motociclistas, cubriendo completamente la cabeza y el mentón. Su diseño aerodinámico reduce el ruido y mejora la estabilidad a altas velocidades, convirtiéndolos en la opción preferida para carretera y uso diario. Seguridad, confort y rendimiento en un solo casco.',
    recommendedUses: [
      'Ciudad y carretera',
      'Viajes largos',
      'Conducción a velocidades medias y altas'
    ],
    keywords: ['casco integral', 'casco de moto seguro', 'casco para carretera', 'casco deportivo'],
    storeLinks: [],
    certificateUrl: 'https://qrco.de/bgROFN',
    certificationType: 'DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '21',
    name: 'UP',
    type: 'Integral',
    price: 0,
    category: ['Carretera', 'Ciudad', 'Viajes Largos'],
    image: '/product_images/up/Up03.jpg',
    images: [
      '/product_images/up/Up03.jpg',
      '/product_images/up/Up02.jpg',
      '/product_images/up/Up01.jpg',
      '/product_images/up/Up04.jpg'
    ],
    description: 'Los cascos integrales ofrecen el máximo nivel de protección para motociclistas, cubriendo completamente la cabeza y el mentón. Su diseño aerodinámico reduce el ruido y mejora la estabilidad a altas velocidades, convirtiéndolos en la opción preferida para carretera y uso diario. Seguridad, confort y rendimiento en un solo casco.',
    recommendedUses: [
      'Ciudad y carretera',
      'Viajes largos',
      'Conducción a velocidades medias y altas'
    ],
    keywords: ['casco integral', 'casco de moto seguro', 'casco para carretera', 'casco deportivo'],
    storeLinks: [],
    certificateUrl: 'https://qrco.de/bgROGe',
    certificationType: 'ECE_DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
  {
    id: '22',
    name: 'SCRAPE',
    type: 'Integral',
    price: 0,
    category: ['Carretera', 'Ciudad', 'Viajes Largos'],
    image: '/product_images/scrape/7502290554599_03.jpg',
    images: [
      '/product_images/scrape/7502290554599_03.jpg',
      '/product_images/scrape/7502290554599_02.jpg',
      '/product_images/scrape/7502290554599_01.jpg',
      '/product_images/scrape/7502290554599_04.jpg'
    ],
    description: 'Los cascos integrales ofrecen el máximo nivel de protección para motociclistas, cubriendo completamente la cabeza y el mentón. Su diseño aerodinámico reduce el ruido y mejora la estabilidad a altas velocidades, convirtiéndolos en la opción preferida para carretera y uso diario. Seguridad, confort y rendimiento en un solo casco.',
    recommendedUses: [
      'Ciudad y carretera',
      'Viajes largos',
      'Conducción a velocidades medias y altas'
    ],
    keywords: ['casco integral', 'casco de moto seguro', 'casco para carretera', 'casco deportivo'],
    storeLinks: [],
    certificateUrl: 'https://qrco.de/bgROH0',
    certificationType: 'ECE_DOT',
    features: {
      abs: true,
      ventilation: true,
      quickRelease: true,
      uvProtection: true,
      removableInterior: true,
      safetyStrap: true,
      bluetooth: true
    }
  },
];

export const ICONS_MAP = {
  abs: { icon: Shield, label: 'Material ABS' },
  ventilation: { icon: Wind, label: 'Ventilación' },
  quickRelease: { icon: X, label: 'Mica fácil liberación' },
  uvProtection: { icon: Sun, label: 'Protección UV' },
  removableInterior: { icon: Check, label: 'Interior removible' },
  safetyStrap: { icon: Award, label: 'Cinta de seguridad' },
  phone: { icon: Phone, label: 'Teléfono' },
  mic: { icon: Mic, label: 'Micrófono' },
  music: { icon: Music, label: 'Música' },
};
